import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './FadeIn';
import { MapPin, Flag, BookMarked, TrendingUp } from 'lucide-react';
const interests = [{
  icon: <MapPin className="w-5 h-5 text-amber" data-id="element-66" />,
  label: 'Bay Area',
  description: 'Born and raised'
}, {
  icon: <Flag className="w-5 h-5 text-amber" data-id="element-67" />,
  label: 'Golf',
  description: 'Since I was 10'
}, {
  icon: <BookMarked className="w-5 h-5 text-amber" data-id="element-68" />,
  label: 'History',
  description: 'Always reading'
}, {
  icon: <TrendingUp className="w-5 h-5 text-amber" data-id="element-69" />,
  label: 'Economics',
  description: 'A real nerd about it'
}];
export function Personal() {
  return <section className="py-20 md:py-32 px-6" data-id="element-70">
      <div className="max-w-6xl mx-auto" data-id="element-71">
        <FadeIn className="mb-12 md:mb-20" data-id="element-72">
          <div className="flex items-center gap-4 max-w-reading mx-auto" data-id="element-73">
            <div className="h-px w-12 bg-amber/30" data-id="element-74" />
            <h2 className="font-playfair text-3xl md:text-4xl text-charcoal italic" data-id="element-75">
              Off the Clock
            </h2>
            <div className="h-px flex-grow bg-amber/30" data-id="element-76" />
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center" data-id="element-77">
          {/* Photo */}
          <FadeIn direction="right" className="lg:col-span-5" data-id="element-78">
            <div className="relative" data-id="element-79">
              {/* Decorative offset frame */}
              <div className="absolute -inset-3 border border-amber/30 rounded-sm hidden md:block" data-id="element-80" />
              <div className="relative aspect-[4/3] sm:aspect-[4/5] overflow-hidden rounded-sm bg-gradient-to-br from-amber-light via-cream-dark to-sage-light shadow-lg" data-id="element-81">
                {/* Replace with your actual photo */}
                <div className="w-full h-full mix-blend-overlay opacity-50 bg-[url('https://images.unsplash.com/photo-1535131749006-b7f58c99034b?q=80&w=1200&auto=format&fit=crop')] bg-cover bg-center" data-id="element-82" />
                <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-charcoal/40 to-transparent" data-id="element-83">
                  <p className="font-playfair italic text-cream text-sm" data-id="element-84">
                    Out on the course
                  </p>
                </div>
              </div>
            </div>
          </FadeIn>

          {/* Text */}
          <div className="lg:col-span-7 space-y-6 text-base md:text-lg text-charcoal/80 leading-relaxed font-light" data-id="element-85">
            <FadeIn delay={0.1} data-id="element-86">
              <p className="font-playfair text-xl md:text-3xl text-charcoal italic leading-snug mb-6 md:mb-8" data-id="element-87">
                Bay Area kid, lifelong golfer, and a sucker for a good history
                book.
              </p>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-88">
              <p data-id="element-89">
                I grew up in the Bay Area and honestly couldn't have asked for a
                better place to come from. It shaped a lot of how I think — open
                to new ideas, comfortable around different kinds of people, and
                always a little restless to keep learning.
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-90">
              <p data-id="element-91">
                I picked up golf when I was 10 and never put it down. It's the
                one thing I've stuck with my whole life, and it's quietly taught
                me more than I realized at the time — patience, how to handle a
                bad break, and the fact that small adjustments usually matter
                more than big ones. When I'm not on the course, I'm probably
                reading about history or going down some economics rabbit hole.
                Both are basically about why people do what they do, which I
                think is the most interesting question there is.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-92">
              <StaggerContainer className="grid grid-cols-2 gap-4 pt-6" data-id="element-93">
                {interests.map((interest, idx) => <StaggerItem key={idx} className="flex items-start gap-3 p-4 bg-cream-dark/40 rounded-lg border border-amber/10" data-id="element-94">
                    <div className="mt-0.5 shrink-0" data-id="element-95">{interest.icon}</div>
                    <div data-id="element-96">
                      <div className="font-playfair text-charcoal text-base" data-id="element-97">
                        {interest.label}
                      </div>
                      <div className="text-charcoal/60 text-sm font-light" data-id="element-98">
                        {interest.description}
                      </div>
                    </div>
                  </StaggerItem>)}
              </StaggerContainer>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}